import React from "react";
import SpecialCard from "./SpecialCard";

const Specials = () => {
  return (
    <div class="p-12 xl:px-32">
      <div class="flex md:flex-1 md:flex-row flex-col justify-between items-center mt-5 mx-5 md:mx-30 lg:mx-40 xl:mx-70 2xl:mx-80">
        <h1 class="font-markazi font-bold text-3xl md:text-5xl">
          This weeks specials!
        </h1>
        <button class="lemonbutton">Online Menu</button>
      </div>
      <div class="flex md:flex-1 flex-col md:flex-row justify-center items-center m-4">
        <SpecialCard
          title="Greek Salad"
          price="12.99"
          desc="The famous greek salad of crispy lettuce, peppers, olives and our Chicago style feta cheese, garnished with crunch garlic and rosemary croutons."
          img="greeksalad.jpg"
        />
        <SpecialCard
          title="Bruschetta"
          price="5.99"
          desc="Our Bruschetta is made from grilled bread that has been smeared with garlic and seasoned with salt and olive oil."
          img="bruschetta.jpg"
        />
        <SpecialCard
          title="Lemon Dessert"
          price="5.00"
          desc="This comes straight from grandma’s recipe book. Every last ingredient has been sourced and is as authentic as can be imagined."
          img="lemondessert.jpg"
        />
      </div>
    </div>
  );
};

export default Specials;
